import { CreateBackupRepoDTO } from "@/services/Backup/interfaces";
import { MinLength, NonEmptyString } from "@/services/FtpUser/validators/string";
import { PositiveNumber } from "@/services/FtpUser/validators/number";


type FormFields = Omit<CreateBackupRepoDTO, 'originServerHostname'>;

type FieldValidator<T> = (value: T) => string | boolean;

type FieldRules = {
  [name in keyof FormFields]: FieldValidator<FormFields[name]>[];
};

export default class CreateBackupRepoForm implements FormFields {
  public backupServer: number = 0;
  public originServerId: string = '';
  public repositoryId: string = '';
  public repositoryPassword: string = '';
  public repositoryPasswordPath: string = '';
  public repositoryPath: string = '';
  public retentionDays: number = 30;

  public rules: FieldRules = {
    backupServer: [
      PositiveNumber("Backup Server ID is required"),
    ],
    originServerId: [
      NonEmptyString("Origin Server ID is required"),
    ],
    repositoryId: [
      NonEmptyString("Repository ID should not be empty!"),
    ],
    retentionDays: [
      PositiveNumber("Retention days is required"),
    ],
  };
}
